/**
 * Shared palette for app and Tailwind. Keep in sync with tailwind.config.js theme.extend.colors.
 * Use for MUI theme, darkDialog, and any inline styles so we don't hardcode hex values.
 */
export const appColors = {
  primary: '#3b82f6',
  primaryDark: '#2563eb',
  accentBlue: '#00d4ff',
  backgroundDark: '#0f172a',
  sidebarDark: '#080c14',
  elevationDark: '#1e293b',
  borderDark: '#334155',
  /** Dialog/surface background (slightly different from elevation for contrast) */
  dialogBg: '#1a1a32',
  /** Dialog borders, input backgrounds */
  dialogBorder: '#242447',
  mutedText: '#9393c8',
  disabledBg: '#242447',
  disabledText: '#666666',
  /** MUI FormHelperText in list-page dialogs (slate-400, readable on elevation-dark) */
  dialogHintText: '#94a3b8',
  formHelperTextError: '#f87171',
} as const;
